import axios from "axios";
// let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwODk3ZTE1ZWRjM2I0MDRkZDFkNjMwZiIsImVtYWlsIjoiam9obndvcmsxQGdtYWlsLmNvbSIsImNvbXBhbnlfaWQiOjIsImlhdCI6MTYxOTYyMzgyNH0.elko4XReeezEnnD8_IZp5xTITXM6hotttUh2_TqIg6g'
const getAuthHeader = () => {
    const token = localStorage.getItem("adminAuthToken");
    return token ? { Authorization: "Bearer " + token } : {};
};
function getApiCall(url) {
    return axios
        .get(process.env.REACT_APP_API_KEY + url, {
            headers: getAuthHeader(),
        })
        .then((data) => {
            return data;
        });
}

function postApiCall(url, body) {
    return axios
        .post(process.env.REACT_APP_API_KEY + url, body, {
            headers: getAuthHeader(),
        })
        .then((data) => {
            return data;
        });
}

function putApiCall(url, body) {
    return axios
        .put(process.env.REACT_APP_API_KEY + url, body, {
            headers: getAuthHeader(),
        })
        .then((data) => {
            return data;
        });
}

function deleteApiCall(url, body) {
    return axios.delete(process.env.REACT_APP_API_KEY + url, {
        headers: getAuthHeader(),
        data: body
    }).then((data) => {
        return data;
    });
}

function previewCall(url, body) {
    return axios
        .post(url, body, {
            dataType: "jsonp",
            contentType: "application/json",
            //headers: { Authorization: AuthStr },
        })
        .then((data) => {
            return data;
        });
}

export { getApiCall, postApiCall, previewCall, putApiCall, deleteApiCall };
